/* A generation request whose HTTP response was lost AFTER dispatch (a Cloudflare 52x
 * proxy timeout, a gateway error without a Lyft Zone error code, or a dropped connection)
 * says nothing about the generation itself: the backend keeps running it and persists the
 * result under the same generationId. These errors are recovered through the existing
 * progress endpoint and the same-generationId replay, never by starting another generation. */

// 408/5xx answers produced by a proxy or gateway rather than by the API (which always sets
// an error.code). 524 is Cloudflare's "a timeout occurred".
const TRANSPORT_LOSS_STATUSES = new Set([408, 502, 503, 504, 520, 521, 522, 523, 524, 525, 526, 527, 530]);

export function isGenerationTransportLoss(error) {
  if (!error || error.name === "AbortError") {
    return false;
  }
  if (error.code) {
    // The API answered with its own code: that answer is authoritative.
    return false;
  }
  // fetch() rejects with a TypeError when the connection is lost; every API answer carries a status.
  return error.status == null
    ? error instanceof TypeError
    : TRANSPORT_LOSS_STATUSES.has(error.status);
}

// The progress wait ended without a confirmed outcome (the progress endpoint stayed
// unreachable). The same generationId is kept: a later explicit retry only replays it.
export const GENERATION_RESULT_UNCERTAIN_MESSAGE =
  "The connection was interrupted during generation. Your program may still have been created, so check your programs before starting a new generation.";
